export enum PurchaseExperienceEnum {
  ONE_STEP = 'one-step',
  TWO_STEP = 'two-steps',
}
